export default IconMultiplier1x => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-multiplier-1x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M9 16v-8l-2 2" />
  <path d="M13 16l4 -4" />
  <path d="M17 16l-4 -4" />
</svg>`;